/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chatbot/keyboard-arrow-down': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<mask id="svgicon_chatbot_keyboard-arrow-down_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path pid="0" _fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgicon_chatbot_keyboard-arrow-down_a)"><path pid="1" d="M12 17.333l-8-8 1.867-1.866L12 13.6l6.133-6.133L20 9.333l-8 8z" _fill="#004CD0"/></g>'
  }
})
